export const SolutionsFirst = () => {
  return (
    <div className="flex justify-center bg-gradient-to-r from-[#E5FDFF] via-[#B9F2FA] to-[#4F78FF] ">
      <div className="relative pt-[80px] pb-[100px] px-[15rem] flex justify-between items-center gap-[200px] w-[1920px]">
        <div className="flex-1 h-full ">
          <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-bold text-[50px] text-[#333333] mt-[100px]">
            光年K-WAN组网业务解决方案
          </div>
          <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-regular text-[24px] text-[#333333] mt-[19px]">
            根据出海企业的业务需求，定制高性价比的专属全球网络连接方案，组建自己的全球专用内部互联网络，实现跨国分支机构异地数据互通互联，支持后期拓展定制
          </div>
          <div className="w-[170px] h-[60px] bg-gradient-to-br from-[#5F97FF] to-[#0182FF] rounded-[10px] mt-[30px] flex items-center justify-center">
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[25px] text-white">
              立即咨询
            </div>
          </div>
        </div>
        <img
          src="/imgs/solutions/right.png"
          className="w-[500px] h-[500px]  z-10"
        />
        <img
          src="/imgs/solutions/bottom.png"
          className="w-full h-[500px] absolute bottom-0 left-0 z-1"
        />
      </div>
    </div>
  );
};
